export default {"src":"/_next/static/media/ap-logo.d92e9388.svg","height":53,"width":57};